module.exports = __webpack_public_path__ + "static/media/Vigoroth_gaussian2.cdd239ed.png";